export default {

  //заполнить данные по штрафам
  loafFines(state, data){
    state.items=data;
  },

  //обновить штраф
  editFine(state, editdata){
    var ind= state.items.findIndex(x=>x.id==editdata.id)
    if(ind!=-1&&ind!=undefined){
        state.items.splice(ind,1,editdata);
      }
  },

  //добавить штраф
  addFine(state, newdata){
      state.items.push(newdata)
  },

  //удалить штраф
  deleteFine(state, fineId){
    var ind= state.items.findIndex(x=>x.id==fineId)
    if(ind!=-1&&ind!=undefined){
        state.items.splice(ind,1);
    }
  },
}
